export const environment = {
  production: true,
  apiCMSHome: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/home",
  apiCMSQuienes: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/who/",
  apiCMSEsg: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/esg/",
  apiCMSContacto: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/contact/",
  apiCmsPosters: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/posters/",
  apiCmsRetalk: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/retalks/",


  // CHANGE THIS TO THE NEW API
  apiCmsPills: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/pills/",
  // ------------------------------
  apiCmsCasos: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/cases",
  apiCmsCasosImages: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/case-image",
  apiCms: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/news/",
  apiCmsTeam: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/teammate",
  apiCmsTeamStatic: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/team",
  apiCmsTeamImages: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/teammate-image",
  apiCmsCareer: "https://api.cms.retailco.es.sprintfinal.net/cms/v1/career",
  apiPropUrl: 'https://api.prop.retailco.es.sprintfinal.net/properties/v1/',
  // mapboxToken: 'pk.eyJ1IjoiZ3V6bWFucyIsImEiOiJjbDVqYTFiOXgwNGdpM2ptb3hxN2Q0NXN5In0.lqQrzINVkeZGJoIy03VaIw',
  mapboxToken: 'pk.eyJ1IjoiZGFuaWVsZ3B0IiwiYSI6ImNsZDk0YTR1ZzA0bngzcHN6c215aGowa3kifQ.6-FRRZMNHL5on_4voMEFWg', // SPRINT
  recaptcha: {
    siteKey: '6Le7uCEkAAAAAGPHGc5cbKxYrRP0RsTNTY4RYuyx',
  }
};

